import { render, staticRenderFns } from "./ButtonSendMessage.vue?vue&type=template&id=6ecea576"
import script from "./ButtonSendMessage.vue?vue&type=script&lang=js"
export * from "./ButtonSendMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports